import axios from 'axios'
// import localforage from 'localforage'

const RESOURCE_NAME = '/settings'

export default {
  get () {
    return axios.get(`${RESOURCE_NAME}`)
  },

  update (data) {
    return axios.post(`${RESOURCE_NAME}`, data)
  }

}
